<template>
    <div class="twoYAxisBar">
        <PublicEcharts :id="id" :chartsData="{ listData }" :options="dealData()" usePropsOptions />
    </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
export default {
    name: "TwoYAxisBar",
    props: {
        listData: {
            type: Array,
            default: () => ([])
        },
        id: {
            type: String,
            default: 'twoYAxisBar'
        },
    },
    components: { PublicEcharts },
    data() {
        return {}
    },
    computed: {},
    methods: {
        dealData() {
            const colors = ['#56D2D8', '#B4B4FC', '#EAD478'];
            let option = {
                color: colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                grid: {
                    top: "60px",
                    left: "40px",
                    right: "40px",
                    bottom: "30px",
                },
                dataZoom: {
                    type: 'inside'
                },
                legend: {
                    data: ['供水温度', '出水温度', '流量']
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        // prettier-ignore
                        data: []
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '温度(℃)',
                        position: 'left',
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#666666'
                            }
                        },
                        axisLabel: {
                            color: "#999",
                            fontSize: 12,
                        }
                    },
                    {
                        type: 'value',
                        name: '流量(L/min)',
                        position: 'right',
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#666666'
                            }
                        },
                        axisLabel: {
                            color: "#999",
                            fontSize: 12,
                        }
                    },

                ],
                series: [{
                    name: '供水温度',
                    type: 'bar',
                    data: []
                },
                {
                    name: '出水温度',
                    type: 'bar',
                    data: []
                },
                {
                    name: '流量',
                    type: 'bar',
                    yAxisIndex: 1,
                    data: []
                }]
            };
            if (this.listData.length) {
                this.listData.forEach((element, index) => {
                    const { name: xname, value = [] } = element
                    option.xAxis[0].data.push(xname)
                    Array.isArray(value) && value.forEach((item, itemIndex) => {
                        const { name, unit, value } = item
                        // if (index === 0) {
                        //     option.yAxis[itemIndex].name = `${name}(${unit})`
                        //     option.legend.data.push(name)
                        //     option.series.push({
                        //         name,
                        //         type: 'bar',
                        //         data: [value],
                        //         yAxisIndex: itemIndex === 0 ? 0 : 1
                        //     },)
                        // } else {
                        //     option.series = option.series.map(i => {
                        //         if (i.name === name) {
                        //             i.data.push(value)
                        //         }
                        //         return i
                        //     })
                        // }
                        option.series = option.series.map(i => {
                            if (i.name === name) {
                                i.data.push(value)
                            }
                            return i
                        })
                    });
                });
            }
            return option;
        }
    },
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.twoYAxisBar {
    width: 725px;
    height: 210px;
}
</style>